import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { categories, getInsightsByCategory } from '../../data/insights';
import './Insights.css';

const InsightsList = () => {
    const navigate = useNavigate();
    const [activeCategory, setActiveCategory] = useState('all');
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        setPosts(getInsightsByCategory(activeCategory));
    }, [activeCategory]);

    return (
        <div className="insights-container">
            <Helmet>
                <title>Insights | StartUs Analysis</title>
                <meta name="description" content="StartUs의 분석 인사이트를 만나보세요. 얼굴 분석, 성향 분석, 스타일 분석에 대한 깊이 있는 칼럼을 제공합니다." />
                <meta property="og:title" content="StartUs Insights" />
                <meta property="og:description" content="StartUs의 분석 인사이트를 만나보세요." />
            </Helmet>

            <header className="insights-header">
                <h1 className="insights-title">StartUs Insights</h1>
                <p className="insights-subtitle">
                    우리가 분석해온 세계관과 사고 구조를 공유합니다.<br />
                    단순한 결과를 넘어, 나를 이해하는 새로운 관점을 발견하세요.
                </p>
            </header>

            <div className="category-filter">
                {categories.map((cat) => (
                    <button
                        key={cat.id}
                        className={`category-btn ${activeCategory === cat.id ? 'active' : ''}`}
                        onClick={() => setActiveCategory(cat.id)}
                    >
                        {cat.name}
                    </button>
                ))}
            </div>

            <div className="insights-grid">
                {posts.map((post) => (
                    <article
                        key={post.id}
                        className="insight-card"
                        onClick={() => navigate(`/insights/${post.id}`)}
                    >
                        <div className="card-thumb-wrapper">
                            <img
                                src={post.thumbnail}
                                alt={post.title}
                                className="card-thumb"
                                onError={(e) => {
                                    e.target.src = 'https://placehold.co/600x400/f5f5f5/cccccc?text=StartUs'; // Fallback image
                                }}
                            />
                        </div>
                        <div className="card-content">
                            <div className="card-meta">
                                <span className="card-category">
                                    {categories.find(c => c.id === post.category)?.name}
                                </span>
                                <span className="card-date">{post.date}</span>
                            </div>
                            <h2 className="card-title">{post.title}</h2>
                            <p className="card-summary">{post.summary}</p>
                            <div className="card-footer">
                                Read More <span>→</span>
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
};

export default InsightsList;
